/**
 * Sorting function for Array.sort() that is case sensitive
 * @param {string} a 
 * @param {string} b 
 * @return integer value used for sorting
 */
const stringComparisonOrdinalCaseSensitive = function (a, b) {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }

  // names must be equal
  return 0;
};

/**
 * Sorting function for Array.sort() that is case insensitive
 * @param {string} a 
 * @param {string} b 
 * @return integer value used for sorting
 */
const stringComparisonOrdinalCaseInsensitive = function (a, b) {
  const aUpperCase = a.toUpperCase(); // ignore upper and lowercase
  const bUpperCase = b.toUpperCase(); // ignore upper and lowercase
  return stringComparisonOrdinalCaseSensitive(aUpperCase, bUpperCase);
};

export {
  stringComparisonOrdinalCaseSensitive,
  stringComparisonOrdinalCaseInsensitive,
};